import { ArrowUpRight } from "lucide-react";
import { productLinks, products } from "../../data/products";
import { Reveal } from "../ui/Reveal";

export function ConnectedStory() {
  return (
    <section id="products" className="connected-section page-container">
      <Reveal className="section-intro">
        <div>
          <span className="eyebrow">Products</span>
          <h2>
            Choose your{" "}
            <br />
            <span>Stratify product.</span>
          </h2>
        </div>
        <p>
          Use Services for bookings, Business to manage your services and
          events, and Deals to buy surplus food.
        </p>
      </Reveal>
      <div className="product-triptych">
        {products.map((product, index) => (
          <Reveal key={product.id} delay={index * 0.08}>
            <a
              id={`${product.id}-chapter`}
              href={productLinks[product.id]}
              className={`product-card product-card-${product.id}`}
            >
              <img
                src={product.photo}
                alt={product.photoAlt}
                width="1100"
                height="733"
                loading="lazy"
              />
              <div className="product-card-head">
                <span>0{index + 1}</span>
                <span>{product.audience}</span>
              </div>
              <div className="product-card-body">
                <h3>{product.shortName}</h3>
                <p>{product.title}</p>
                <span className="product-card-action">
                  {product.action}
                  <ArrowUpRight size={16} />
                </span>
              </div>
            </a>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
